import { render, staticRenderFns } from "./CalcularFrete.vue?vue&type=template&id=5774f5e0&scoped=true"
import script from "./CalcularFrete.vue?vue&type=script&lang=js"
export * from "./CalcularFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5774f5e0",
  null
  
)

export default component.exports